import { render, staticRenderFns } from "./PrintPosFa.vue?vue&type=template&id=68f774e9&scoped=true"
import script from "./PrintPosFa.vue?vue&type=script&lang=js"
export * from "./PrintPosFa.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFa.vue?vue&type=style&index=0&id=68f774e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f774e9",
  null
  
)

export default component.exports